/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientContact
 */
export interface PccPatientContact {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    gender?: PccPatientContactGenderEnum;
    /**
     * 
     */
    country?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    postal_code?: string;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    cell_phone?: string;
    /**
     * 
     */
    home_phone?: string;
    /**
     * 
     */
    office_phone?: string;
    /**
     * 
     */
    other_phone?: string;
    /**
     * 
     */
    fax?: string;
    /**
     * 
     */
    dob?: string | null;
    /**
     * 
     */
    relationship?: string;
    /**
     * 
     */
    pcc_pending_contact_id?: string;
}


/**
 * @export
 */
export const PccPatientContactGenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown',
} as const;
export type PccPatientContactGenderEnum = typeof PccPatientContactGenderEnum[keyof typeof PccPatientContactGenderEnum];


/**
 * Check if a given object implements the PccPatientContact interface.
 */
export function instanceOfPccPatientContact(value: object): value is PccPatientContact {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function PccPatientContactFromJSON(json: any): PccPatientContact {
    return PccPatientContactFromJSONTyped(json, false);
}

export function PccPatientContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'country': json['country'] == null ? undefined : json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postal_code': json['postal_code'] == null ? undefined : json['postal_code'],
        'address': json['address'] == null ? undefined : json['address'],
        'email': json['email'] == null ? undefined : json['email'],
        'cell_phone': json['cell_phone'] == null ? undefined : json['cell_phone'],
        'home_phone': json['home_phone'] == null ? undefined : json['home_phone'],
        'office_phone': json['office_phone'] == null ? undefined : json['office_phone'],
        'other_phone': json['other_phone'] == null ? undefined : json['other_phone'],
        'fax': json['fax'] == null ? undefined : json['fax'],
        'dob': json['dob'] === undefined ? undefined : json['dob'] === null ? null : json['dob'],
        'relationship': json['relationship'] == null ? undefined : json['relationship'],
        'pcc_pending_contact_id': json['pcc_pending_contact_id'] == null ? undefined : json['pcc_pending_contact_id'],
    };
}

export function PccPatientContactToJSON(json: any): PccPatientContact {
    return PccPatientContactToJSONTyped(json, false);
}

export function PccPatientContactToJSONTyped(value?: PccPatientContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'gender': value['gender'],
        'country': value['country'],
        'city': value['city'],
        'state': value['state'],
        'postal_code': value['postal_code'],
        'address': value['address'],
        'email': value['email'],
        'cell_phone': value['cell_phone'],
        'home_phone': value['home_phone'],
        'office_phone': value['office_phone'],
        'other_phone': value['other_phone'],
        'fax': value['fax'],
        'dob': value['dob'],
        'relationship': value['relationship'],
        'pcc_pending_contact_id': value['pcc_pending_contact_id'],
    };
}

